import React, {Component, Fragment} from 'react'
import {Link} from 'react-router-dom'
import {
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    ListGroup,
    ListGroupItem,
} from 'reactstrap'
import autobind from 'auto-bind'

import * as API from 'SDK/api'
import GenericWidgets from 'SDK/ui/widgets'
import GenericWidgetModal from './genericWidgetConfigurationModal'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)

        this.state = {
            outputs: [],
            genericSelected: null,
            generic: GenericWidgets,
            genericModalOpen: false,
        }
    }

    toggleGenericModal() {
        this.setState({
            genericModalOpen: !this.state.genericModalOpen,
        })
    }

    configureGenericComponent(component) {
        this.setState({
            genericModalOpen: true,
            genericSelected: component,
        })
    }

    async fetchOutputs() {
        let states = await API.get('definitions', 1)

        states = [...new Set(states.map((x) => x.name))]

        const records = await API.get('flows', 2)
        if (!records) {
            alert('Cannot fetch list of outputs!')
            return
        }

        let outputs = []

        for (let i in records) {
            outputs = outputs.concat(
                records[i].template
                    .filter((n) => n.transform === '$output')
                    .map((n) => n.params.a)
                    .sort()
            )
        }

        outputs = [...new Set(outputs)]

        outputs = outputs.concat(states)

        this.setState({outputs})
    }

    async componentWillMount() {
        await this.fetchOutputs()
    }

    render() {
        const {modal, toggleModal} = this.props

        return (
            <Fragment>
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Module Library
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs="12">
                                {this.state.generic.map((x) => {
                                    const instance = new x()

                                    if (instance.deprecated) return null

                                    let locked = false
                                    for (let i in instance.requiredOutputs) {
                                        if (
                                            !this.state.outputs.find(
                                                (o) =>
                                                    o ===
                                                    instance.requiredOutputs[i]
                                            )
                                        ) {
                                            locked = true
                                        }
                                    }

                                    if (locked) {
                                        return (
                                            <Button
                                                className="btn btn-warning btn-block"
                                                key={instance.id}
                                                onClick={() => {
                                                    this.configureGenericComponent(
                                                        x
                                                    )
                                                }}
                                                style={{
                                                    color: '#FFF',
                                                    marginTop: 5,
                                                    marginBottom: 5,
                                                }}>
                                                {instance.id}
                                            </Button>
                                        )
                                    } else {
                                        return (
                                            <Button
                                                className="btn btn-secondary btn-block"
                                                key={instance.id}
                                                onClick={() => {
                                                    this.configureGenericComponent(
                                                        x
                                                    )
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    marginTop: 5,
                                                    marginBottom: 5,
                                                }}>
                                                {instance.id}
                                            </Button>
                                        )
                                    }
                                })}
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                {this.state.genericModalOpen ? (
                    <GenericWidgetModal
                        toggleModal={this.toggleGenericModal}
                        modal={this.state.genericModalOpen}
                        component={this.state.genericSelected}
                        loadComponent={this.props.loadGenericComponent}
                    />
                ) : null}

                {this.state.loading ? <div className="loading" /> : null}
            </Fragment>
        )
    }
}
